// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  margin-bottom: 1rem;
  border-spacing: 0px 1px;
  border-collapse: separate;
}

th,
td {
  padding: 2px;
  margin-bottom: 1px;
  text-align: left;
  height: 100%;
}

.table-header {
  width: 100%;
  font-size: 20px;
  font-weight: 600;
}

td {
  background-color: white;
  text-align: left;
  border-radius: 3px;
  box-shadow: 1px 1px 1px 1px lightgray;
  background-clip: border-box;
}

th {
  font-weight: 500;
  padding-left: 1rem !important;
}

input {
  width: 50%;
  background-color: white;
}

input.ng-dirty.ng-invalid.ng-touched {
  border: 1px solid red;
}

input:focus {
  outline: 0;
}

input:disabled {
  background-color: transparent;
}

.ion-img-icon {
  height: 60px;
  width: 60px;
  margin-left: -20px;
}

.button-container {
  width: 75%;
  margin: auto;
}

.locked {
  background-color: transparent;
  box-shadow: 0px 0px 0px 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/layouts/main/pages/calibration-modal/calibration-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,uBAAA;EACA,yBAAA;AACF;;AAEA;;EAEE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qCAAA;EACA,2BAAA;AACF;;AAEA;EACE,gBAAA;EACA,6BAAA;AACF;;AAEA;EACE,UAAA;EACA,uBAAA;AACF;;AAAE;EACE,qBAAA;AAEJ;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,UAAA;EACA,YAAA;AACF;;AAEA;EACE,6BAAA;EACA,2BAAA;AACF","sourcesContent":["table {\r\n  margin-bottom: 1rem;\r\n  border-spacing: 0px 1px;\r\n  border-collapse: separate;\r\n}\r\n\r\nth,\r\ntd {\r\n  padding: 2px;\r\n  margin-bottom: 1px;\r\n  text-align: left;\r\n  height: 100%;\r\n}\r\n\r\n.table-header {\r\n  width: 100%;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\ntd {\r\n  background-color: white;\r\n  text-align: left;\r\n  border-radius: 3px;\r\n  box-shadow: 1px 1px 1px 1px lightgray;\r\n  background-clip: border-box;\r\n}\r\n\r\nth {\r\n  font-weight: 500;\r\n  padding-left: 1rem !important;\r\n}\r\n\r\ninput {\r\n  width: 50%;\r\n  background-color: white;\r\n  &.ng-dirty.ng-invalid.ng-touched {\r\n    border: 1px solid red;\r\n  }\r\n}\r\n\r\ninput:focus {\r\n  outline: 0;\r\n}\r\n\r\ninput:disabled {\r\n  background-color: transparent;\r\n}\r\n\r\n.ion-img-icon {\r\n  height: 60px;\r\n  width: 60px;\r\n  margin-left: -20px;\r\n}\r\n\r\n.button-container {\r\n  width: 75%;\r\n  margin: auto;\r\n}\r\n\r\n.locked {\r\n  background-color: transparent;\r\n  box-shadow: 0px 0px 0px 0px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
